import { FC } from 'react';
import { ContractData } from '../../../../../types/essential-ui/ContractData';
import LeftPanelContractModal from './LeftPanelContractModal';
import RightPanelContractModal from './RightPanelContractModal';
import TermDetails from './TermDetails';
import VehicleDetails from './VehicleDetails';
import WarrantyDetails from './WarrantyDetails';

import FinancePaymentDetails from './FinancePaymentDetails';
import GeneralPaymentDetails from './GeneralPaymentDetails';
import LeasePaymentDetails from './LeasePaymentDetails';

import styled from 'styled-components';

import { useState } from 'react';
import { BuildPathFromParameters } from '../../../../../services/api/ApiMethods';
import { GetOneFromPath } from '../../../../../services/api/GenericClient';
import { theme } from '../../../../../styles/theme';
import { Badge } from '../../../../style/essential-ui/Badge';
import { ContractModalPlaceholder } from './ContractModalPlaceholder';

export type ContractDataProps = {
  data: ContractData;
  priorLeaseId?: string | null | undefined;
  dealerId?: string;
};

const ContractDetails: FC<ContractDataProps> = (props) => {
  const dealType = props.data.dealType;
  const [selectedTab, SetSelectedTab] = useState('current');
  const isLeaseBuyout =
    props.priorLeaseId !== undefined &&
    props.priorLeaseId !== null &&
    props.priorLeaseId !== '00000000-0000-0000-0000-000000000000';
  const [previousContract, SetPreviousContract] = useState<ContractData>();
  const [loading, SetLoading] = useState(false);

  const getPreveiousContractDetails = async (closedDealId: string, chromeId?: string) => {
    const method = '/dealsheet/contract';
    try {
      const data = {
        dealerId: props.dealerId,
        id: closedDealId,
        chromeId: chromeId ?? props.data!.chromeId.toString(),
      };
      const path = BuildPathFromParameters(method, data);
      const response = await GetOneFromPath<ContractData>(path);
      if (response) {
        SetPreviousContract(response);
      }
      SetLoading(false);
    } catch {
      SetSelectedTab('current');
      SetLoading(false);
    }
  };

  const viewPreviousContract = () => {
    SetSelectedTab('previous');
    SetLoading(true);
    getPreveiousContractDetails(props.priorLeaseId, props.data.chromeId.toString());
  };

  return (
    <div>
      {isLeaseBuyout && (
        <TabPanel>
          <span className={selectedTab == 'current' ? 'selected-tab' : ''}>
            <a onClick={() => SetSelectedTab('current')}>Current</a>
          </span>
          <span className={selectedTab == 'previous' ? 'selected-tab' : ''}>
            <a onClick={() => viewPreviousContract()}>Previous</a>
          </span>
        </TabPanel>
      )}

      <ModalBody data-testid='contract-details'>
        {selectedTab == 'current' ? (
          <>
            <LeftPanelContractModal backgroundColor={theme.palette.gray}>
              {isLeaseBuyout && (
                <BadgeContainer>
                  <Badge dealType={props.data.dealType} isOpenedFromDealsheet={true}>
                    {props.data.dealType}
                  </Badge>
                </BadgeContainer>
              )}
              <VehicleDetails data={props.data} />
            </LeftPanelContractModal>
            <RightPanelContractModal>
              <TermDetails data={props.data} />
              <PaymentDetailsBody data-testid='contract-payment-details'>
                {dealType === 'Finance' ? (
                  <FinancePaymentDetails data={props.data} />
                ) : dealType === 'Lease' ? (
                  <LeasePaymentDetails data={props.data} />
                ) : (
                  <></>
                )}
                <GeneralPaymentDetails data={props.data} />
              </PaymentDetailsBody>
              <WarrantyDetails data={props.data} />
            </RightPanelContractModal>
          </>
        ) : !loading ? (
          <>
            <LeftPanelContractModal backgroundColor={theme.palette.gray}>
              <BadgeContainer>
                <Badge dealType={previousContract.dealType} isOpenedFromDealsheet={true}>
                  {previousContract.dealType}
                </Badge>
              </BadgeContainer>
              <VehicleDetails data={previousContract} />
            </LeftPanelContractModal>
            <RightPanelContractModal>
              <TermDetails data={previousContract} />
              <PaymentDetailsBody data-testid='contract-payment-details'>
                {previousContract.dealType === 'Finance' ? (
                  <FinancePaymentDetails data={previousContract} />
                ) : previousContract.dealType === 'Lease' ? (
                  <LeasePaymentDetails data={previousContract} />
                ) : (
                  <></>
                )}
                <GeneralPaymentDetails data={previousContract} />
              </PaymentDetailsBody>
              <WarrantyDetails data={previousContract} />
            </RightPanelContractModal>
          </>
        ) : (
          <ContractModalPlaceholder />
        )}
      </ModalBody>
    </div>
  );
};

export default ContractDetails;

const ModalBody = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  max-height: 500px;
`;

const PaymentDetailsBody = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 50%;
`;

const TabPanel = styled.div`
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #cccccc;
  span {
    margin-right: 20px;
    a {
      text-decoration: none;
      color: #593487;
      cursor: pointer;
    }
  }
  .selected-tab {
    border-bottom: 2px solid #593487;
  }
`;

const BadgeContainer = styled.div`
  padding-top: 18px;
  padding-left: 18px;
`;
